import React from 'react';
import './Earn.css';
import AnimatedSection from '../AnimatedSection';

function Earn() {
    return (
        <section className="earn" id="earn">
            <div className="earn-wrapper">
            <AnimatedSection animationType="slide-up">
                <div className="lp-section-header">
                    <h2 className="lp-section-title">
                        Split & <span className="lp-section-title-highlight">Earn Points</span>
                    </h2>
                    <p className="lp-section-subtitle">
                        Turn everyday splits into points, challenges, and squad bragging rights.
                    </p>
                </div>
            </AnimatedSection>

            <div className="earn-grid">
                <AnimatedSection animationType="slide-up" stagger={1}>
                    <div className="earn-card">
                        <div className="earn-card-image">
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fearn-1.png?alt=media&token=923a1bf8-9c27-46f7-8168-a1e718d6d9c5"
                                alt="Quests & Badges"
                            />
                        </div>
                        <div className="earn-card-content">
                            <h3 className="lp-section-card-label-h3">Quests & Badges</h3>
                            <p className="lp-section-card-body-p">Complete squad challenges, unlock badges, and earn points as you pay together.</p>
                        </div>
                    </div>
                </AnimatedSection>

                <AnimatedSection animationType="slide-up" stagger={2}>
                    <div className="earn-card">
                        <div className="earn-card-image">
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fearn-2.png?alt=media&token=cbb46a4e-c138-46e0-91cb-577c262b49f0"
                                alt="Global Leaderboard"
                            />
                        </div>
                        <div className="earn-card-content">
                            <h3 className="lp-section-card-label-h3">Global Leaderboard</h3>
                            <p className="lp-section-card-body-p">Climb the ranks by splitting, completing quests, and rolling degen mode.</p>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
            </div>
        </section>
    );
}

export default Earn;

